<template>
  <Dashboard grafana-path="/d/zZGOLGT4L/fico-distractions-pivot" />
</template>

<script>
// @ is an alias to /src
import Dashboard from "@/components/Dashboard.vue";

export default {
  name: "FicoDistractionsDriverPivot",

  routing: {
    localizationKey: "menu.tab.distractions",
    icon: "mdi-table",
    path: "/fico_distractions",
    hasAccess: (user) => user.isAdmin || user.isManager,
  },

  components: {
    Dashboard,
  },
};
</script>
